import React, { useState, useEffect, FC } from 'react'
import { Table, Modal, message } from 'antd'
import { Link, useHistory } from 'react-router-dom'
import { SearchBar, EndCustomerAccountForm, useBreakpoints } from '../../../components'
import { EndCustomer, EndCustomerFormValues, Reseller } from '../../../types'
import { resellerService, endCustomerService } from '../../../services'
import styles from './index.module.less'

const { Column } = Table

interface ChildAccountsProps {
	reseller: Reseller
}

const ChildAccounts: FC<ChildAccountsProps> = ({ reseller }) => {
	const [isVisible, setIsVisible] = useState<boolean>(false)
	const [endCustomers, setEndCustomers] = useState<EndCustomer[]>(null)
	const [filter, setFilter] = useState<string>('')
	const breakpoints = useBreakpoints()
	const history = useHistory()

	const createEndCustomer = async (values: EndCustomerFormValues): Promise<void> => {
		const { data } = await endCustomerService.create(values)
		setIsVisible(false)
		history.push(`/endcustomer/${data.id}/details`)
	}

	useEffect(() => {
		const init = async () => {
			try {
				const { data } = await resellerService.getChildren(reseller.id)
				setEndCustomers(data)
			} catch (error) {
				const defaultErrorMessage = 'Something went wrong, unable to get children for reseller.'
				message.error(defaultErrorMessage)
			}
		}

		init()
	}, [reseller.id])

	const filteredEndCustomers = endCustomers ? endCustomers.filter(endCustomer => endCustomer.name.toLowerCase().includes(filter.toLowerCase())) : []

	return (
		<>
			<SearchBar
				className={styles.filter}
				search={setFilter}
				buttonProps={{
					onClick: (): void => setIsVisible(true),
					children: 'New End Customer',
					icon: 'plus'
				}}
				placeholder='Filter end customers'
			/>
			<Table rowKey='id' loading={endCustomers === null} dataSource={filteredEndCustomers}>
				<Column
					title='Name'
					dataIndex='name'
					render={(_, endCustomer: EndCustomer): React.ReactNode => <Link to={`/endcustomer/${endCustomer.id}/licenses`}>{endCustomer.name}</Link>}
				/>
				<Column title='Contact' dataIndex='contact' />
			</Table>
			<Modal centered={breakpoints.md} visible={isVisible} onCancel={(): void => setIsVisible(false)} title={`Create new end customer`} footer={null}>
				<EndCustomerAccountForm submit={createEndCustomer} reseller={reseller} />
			</Modal>
		</>
	)
}

export default ChildAccounts
